<div class="page-container">
  @if (currentUser$ | async; as user) {
    @if (section$ | async; as section) {
      <app-toolbar [title]="getSectionTranslationKey(section) | translate" [backButtonLink]="['/app', 'meetings']"></app-toolbar>
      <div class="page">
        <div class="form-container wrapper">
          @if (section === 'language') {
            @if (userSettings$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
              } @else {
                <div class="section general">
                  <div class="locale-selection">
                    <mat-form-field>
                      <mat-label translate="SETTINGS.LOCALE_LABEL"></mat-label>
                      <mat-select required name="locale" [(ngModel)]="userData.locale" (selectionChange)="updateUser()">
                        <mat-option value="EN_US">{{ 'SETTINGS.LOCALES.EN_US' | translate }}</mat-option>
                        <mat-option value="EN_GB">{{ 'SETTINGS.LOCALES.EN_GB' | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <h3 translate="SETTINGS.TIMEZONE"></h3>
                  <mat-divider class="with-margin"></mat-divider>
                  <div class="timezone-selection">
                    <app-timezone-selector [(ngModel)]="userData.timezone" (ngModelChange)="updateUser()"></app-timezone-selector>
                  </div>
                  @if (user.role === 'SUPPORT') {
                    <h3 class="appearance-heading" translate="SETTINGS.APPEARANCE"></h3>
                    <mat-divider class="with-margin"></mat-divider>
                    <div class="appearance">
                      <mat-slide-toggle [checked]="user.isDarkModeEnabled" (change)="setDarkModeEnabled($event)" name="dark-mode" labelPosition="after">
                        {{ 'SETTINGS.DARK_MODE' | translate }}
                      </mat-slide-toggle>
                    </div>
                  }
                </div>
              }
            }
          } @else if (section === 'calendar') {
            @if (userSettings$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
              } @else {
                <div class="section connected-calendars">
                  <h3 translate="SETTINGS.CONNECTED_CALENDARS"></h3>
                  <mat-divider class="with-margin"></mat-divider>
                  <div class="item">
                    @for (provider of userData.calendarProviders; track provider.email) {
                      <div class="calendar-provider">
                        <div class="left">
                          @if (isGoogleProvider(provider.provider)) {
                            <img src="assets/images/calendar-providers/google.png" />
                            <div class="name" translate="SETTINGS.GOOGLE_CALENDAR"></div>
                          } @else {
                            <img src="assets/images/calendar-providers/office-365.png" />
                            <div class="name" translate="SETTINGS.OFFICE_365_CALENDAR"></div>
                          }
                        </div>
                        <div class="right">
                          @if (provider.email !== null) {
                            <div class="email">
                              <mat-chip
                                [class.clickable]="!isPrimaryEmail(provider.email)"
                                [matTooltip]="(isPrimaryEmail(provider.email) ? 'COMMON.PRIMARY_EMAIL' : 'COMMON.UNLINK') | translate"
                                (click)="!isPrimaryEmail(provider.email) && unlinkCalendarProvider(provider.provider)"
                              >
                                {{ provider.email }}
                              </mat-chip>
                            </div>
                          } @else {
                            <button mat-flat-button (click)="linkCalendarProvider(provider.provider)" translate="COMMON.CONNECT"></button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                @if (organizationSettings$ | async; as result) {
                  @if (result.isSuccess) {
                    <div class="section attendance-rules">
                      <h3 translate="SETTINGS.ATTENDANCE_RULES"></h3>
                      <mat-divider></mat-divider>
                      <app-join-settings [data]="userData" [organization]="organizationData" (update)="updateUser()"></app-join-settings>
                    </div>
                    @if (user.role === 'ADMIN' || user.role === 'SUPPORT') {
                      <div class="section organization-attendance-rules">
                        <h3 translate="SETTINGS.ATTENDANCE_RULES_ORGANIZATION"></h3>
                        <mat-divider></mat-divider>
                        <div class="item">
                          <mat-slide-toggle
                            [ngModel]="settingValue('joinMeetingInternal')"
                            (ngModelChange)="setSetting('joinMeetingInternal', $event)"
                            (change)="updateOrganization()"
                            name="join-meeting-internal"
                            labelPosition="after"
                          >
                            {{ 'SETTINGS.JOIN_CALL_INTERNAL' | translate }}
                          </mat-slide-toggle>
                        </div>
                        <div class="item">
                          <mat-slide-toggle
                            [ngModel]="settingValue('joinMeetingExternal')"
                            (ngModelChange)="setSetting('joinMeetingExternal', $event)"
                            (change)="updateOrganization()"
                            name="join-meeting-external"
                            labelPosition="after"
                          >
                            {{ 'SETTINGS.JOIN_CALL_EXTERNAL' | translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                      <div class="item">
                        <mat-checkbox
                          name="include-action-items"
                          labelPosition="after"
                          [ngModel]="!settingValue('freezeJoinSettings')"
                          (ngModelChange)="toggleJoinSettingsFreezing()"
                        >
                          {{ 'SETTINGS.ALLOW_USERS_TO_CHANGE_JOIN_SETTINGS' | translate }}
                        </mat-checkbox>
                      </div>
                    }
                  }
                }
              }
            }
          } @else if (section === 'assistant') {
            @if (organizationSettings$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
              } @else {
                <div class="section assistant">
                  <h3 translate="SETTINGS.ASSISTANT"></h3>
                  <mat-divider class="with-margin"></mat-divider>
                  <div class="chat-messages">
                    <div class="item">
                      <mat-slide-toggle
                        [ngModel]="settingValue('shareUrlOptOut')"
                        (ngModelChange)="setSetting('shareUrlOptOut', $event)"
                        (change)="updateOrganization()"
                        name="send-hang-up-message"
                        labelPosition="after"
                      >
                        {{ 'SETTINGS.SEND_HANG_UP_MESSAGE' | translate }}
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              }
            }
          } @else if (section === 'transcript') {
            @if (organizationSettings$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
              } @else {
                <div class="section transcript">
                  <h3 translate="SETTINGS.TRANSCRIPT"></h3>
                  <mat-divider class="with-margin"></mat-divider>
                  <div class="output-language">
                    <mat-form-field>
                      <mat-label translate="SETTINGS.OUTPUT_LANGUAGE"></mat-label>
                      <mat-select
                        required
                        name="role"
                        [ngModel]="settingValue('transcriberOutputLanguage')"
                        (ngModelChange)="setSetting('transcriberOutputLanguage', $event)"
                        (selectionChange)="updateOrganization()"
                      >
                        <mat-option value="EN">{{ 'SETTINGS.OUTPUT_LANGUAGES.ENGLISH' | translate }}</mat-option>
                        <mat-option value="ORIGINAL">{{ 'SETTINGS.OUTPUT_LANGUAGES.ORIGINAL' | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              }
            }
          } @else if (section === 'minutes-styling') {
            @if (organizationSettings$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
              } @else {
                <div class="section minutes-styling">
                  <h3 translate="MINUTES_STYLING.TITLE"></h3>
                  <app-minutes-styling
                    [data]="resolvedMinutesStyling"
                    [enabledMinutesLanguages]="organizationData.client.enabledMinutesLanguages"
                    (update)="updateMinutesStyling($event); updateOrganization()"
                  ></app-minutes-styling>
                </div>
              }
            }
          } @else if (section === 'sharing') {
            @if (organizationSettings$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
              } @else {
                <div class="section sharing">
                  <h3 translate="SETTINGS.SHARING"></h3>
                  <mat-divider class="with-margin"></mat-divider>
                  <div class="item">
                    <mat-slide-toggle
                      [ngModel]="settingValue('allowTranscriptDownload')"
                      (ngModelChange)="setSetting('allowTranscriptDownload', $event)"
                      (change)="updateOrganization()"
                      name="allow-transcript-download"
                      labelPosition="after"
                    >
                      {{ 'SETTINGS.ALLOW_TRANSCRIPT_DOWNLOAD' | translate }}
                    </mat-slide-toggle>
                  </div>
                  <div class="item">
                    <mat-slide-toggle
                      [ngModel]="settingValue('allowVideoDownload')"
                      (ngModelChange)="setSetting('allowVideoDownload', $event)"
                      (change)="updateOrganization()"
                      name="allow-video-download"
                      labelPosition="after"
                    >
                      {{ 'SETTINGS.ALLOW_VIDEO_DOWNLOAD' | translate }}
                    </mat-slide-toggle>
                  </div>
                  <div class="item">
                    <mat-slide-toggle
                      [ngModel]="settingValue('allowMinutesDownload')"
                      (ngModelChange)="setSetting('allowMinutesDownload', $event)"
                      (change)="updateOrganization()"
                      name="allow-minutes-download"
                      labelPosition="after"
                    >
                      {{ 'SETTINGS.ALLOW_MINUTES_DOWNLOAD' | translate }}
                    </mat-slide-toggle>
                  </div>
                  <div class="item">
                    <mat-slide-toggle
                      [ngModel]="settingValue('allowOutlineDownload')"
                      (ngModelChange)="setSetting('allowOutlineDownload', $event)"
                      (change)="updateOrganization()"
                      name="allow-outline-download"
                      labelPosition="after"
                    >
                      {{ 'SETTINGS.ALLOW_OUTLINE_DOWNLOAD' | translate }}
                    </mat-slide-toggle>
                  </div>
                </div>
              }
            }
          } @else if (section === 'notifications') {
            @if ((organizationSettings$ | async)?.isSuccess) {
              @if (userSettings$ | async; as result) {
                @if (result.isPending) {
                  <app-spinner></app-spinner>
                } @else if (result.isError) {
                  <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
                } @else {
                  <div class="section retention">
                    <h3 translate="SETTINGS.NOTIFICATIONS"></h3>
                    <mat-divider class="with-margin"></mat-divider>
                    <div class="item">
                      <mat-slide-toggle
                        [ngModel]="userData.sendUpcomingCallReminderEmail"
                        (ngModelChange)="updateSendUpcomingCallReminderEmail($event)"
                        name="send-upcoming-call-reminder-email"
                        labelPosition="after"
                      >
                        {{ 'SETTINGS.SEND_UPCOMING_CALL_REMINDER_EMAIL' | translate }}
                      </mat-slide-toggle>
                    </div>
                    <div class="item">
                      <mat-slide-toggle
                        [ngModel]="userData.notifyWhenPostProcessingCompletes"
                        (ngModelChange)="updateNotifyWhenPostProcessingCompletes($event)"
                        name="notify-when-post-processing-completes"
                        labelPosition="after"
                      >
                        {{ 'SETTINGS.NOTIFY_WHEN_POST_PROCESSING_COMPLETES' | translate }}
                      </mat-slide-toggle>
                    </div>
                    <div class="item">
                      <mat-slide-toggle
                        [ngModel]="userData.sendWeeklyDigestEmail ?? settingValue('sendWeeklyDigestEmail')"
                        (ngModelChange)="updateSendWeeklyDigestEmail($event)"
                        name="send-weekly-digest-email"
                        labelPosition="after"
                      >
                        {{ 'SETTINGS.SEND_WEEKLY_DIGEST_EMAIL' | translate }}
                      </mat-slide-toggle>
                    </div>
                    <div class="item">
                      <mat-slide-toggle
                        [ngModel]="userData.sendSoftDeletionWarningEmail ?? settingValue('sendSoftDeletionWarningEmail')"
                        (ngModelChange)="updateSendSoftDeletionWarningEmail($event)"
                        name="send-soft-deletion-warning-email"
                        labelPosition="after"
                      >
                        {{ 'SETTINGS.SEND_SOFT_DELETION_WARNING_EMAIL' | translate }}
                      </mat-slide-toggle>
                    </div>
                    <div class="item">
                      <mat-slide-toggle
                        [ngModel]="userData.sendSoftDeletionConfirmationEmail ?? settingValue('sendSoftDeletionConfirmationEmail')"
                        (ngModelChange)="updateSendSoftDeletionConfirmationEmail($event)"
                        name="send-soft-deletion-confirmation-email"
                        labelPosition="after"
                      >
                        {{ 'SETTINGS.SEND_SOFT_DELETION_CONFIRMATION_EMAIL' | translate }}
                      </mat-slide-toggle>
                    </div>
                    <div class="item">
                      <mat-slide-toggle
                        [ngModel]="userData.sendAssistantAccessDeniedEmail ?? settingValue('sendAssistantAccessDeniedEmail')"
                        (ngModelChange)="updateSendAssistantAccessDeniedEmail($event)"
                        name="send-assistant-access-denied-email"
                        labelPosition="after"
                      >
                        {{ 'SETTINGS.SEND_ASSISTANT_ACCESS_DENIED_EMAIL' | translate }}
                      </mat-slide-toggle>
                    </div>

                    @if (user.role === 'ADMIN' || user.role === 'SUPPORT') {
                      <div class="organization-settings">
                        <h3 translate="SETTINGS.ORGANIZATION_NOTIFICATION_SETTINGS"></h3>
                        <mat-divider class="with-margin"></mat-divider>
                        <mat-slide-toggle
                          [ngModel]="settingValue('sendUpcomingCallReminderEmail')"
                          (ngModelChange)="updateOrganization()"
                          name="send-upcoming-call-reminder-email-for-organization"
                          labelPosition="after"
                        >
                          {{ 'SETTINGS.SEND_UPCOMING_CALL_REMINDER_EMAIL_FOR_ORGANIZATION' | translate }}
                        </mat-slide-toggle>

                        <div class="item">
                          <mat-slide-toggle
                            [ngModel]="settingValue('sendWeeklyDigestEmail')"
                            (ngModelChange)="setSetting('sendWeeklyDigestEmail', $event)"
                            (change)="updateOrganization()"
                            name="send-weekly-digest-email-for-organization"
                            labelPosition="after"
                          >
                            {{ 'SETTINGS.SEND_WEEKLY_DIGEST_EMAIL_FOR_ORGANIZATION' | translate }}
                          </mat-slide-toggle>
                        </div>

                        <div class="item">
                          <mat-slide-toggle
                            [ngModel]="settingValue('sendSoftDeletionWarningEmail')"
                            (ngModelChange)="setSetting('sendSoftDeletionWarningEmail', $event)"
                            (change)="onSoftDeletionWarningEmailChange()"
                            name="send-soft-deletion-warning-email-for-organization"
                            labelPosition="after"
                          >
                            {{ 'SETTINGS.SEND_SOFT_DELETION_WARNING_EMAIL' | translate }}
                          </mat-slide-toggle>
                        </div>

                        @if (settingValue('sendSoftDeletionWarningEmail')) {
                          <div class="item">
                            <mat-form-field subscriptSizing="dynamic">
                              <mat-label>{{ 'SETTINGS.SOFT_DELETION_WARNING_HOURS' | translate }}</mat-label>
                              <input
                                matInput
                                [ngModel]="settingValue('softDeletionWarningHours')"
                                (ngModelChange)="setSoftDeletionWarningHours($event)"
                                name="soft-deletion-warning-hours"
                                required
                                pattern="^[1-9][0-9]*$"
                              />
                              <mat-error translate="SETTINGS.SOFT_DELETION_WARNING_HOURS_ERROR"></mat-error>
                            </mat-form-field>
                          </div>
                        }

                        <div class="item">
                          <mat-slide-toggle
                            [ngModel]="settingValue('sendSoftDeletionConfirmationEmail')"
                            (ngModelChange)="setSetting('sendSoftDeletionConfirmationEmail', $event)"
                            (change)="updateOrganization()"
                            name="send-soft-deletion-confirmation-email-for-organization"
                            labelPosition="after"
                          >
                            {{ 'SETTINGS.SEND_SOFT_DELETION_CONFIRMATION_EMAIL' | translate }}
                          </mat-slide-toggle>
                        </div>

                        <div class="item">
                          <mat-slide-toggle
                            [ngModel]="settingValue('sendHardDeletionConfirmationEmail')"
                            (ngModelChange)="setSetting('sendHardDeletionConfirmationEmail', $event)"
                            (change)="updateOrganization()"
                            name="send-hard-deletion-confirmation-email"
                            labelPosition="after"
                          >
                            {{ 'SETTINGS.SEND_HARD_DELETION_CONFIRMATION_EMAIL' | translate }}
                          </mat-slide-toggle>
                        </div>

                        <div class="item">
                          <mat-slide-toggle
                            [ngModel]="settingValue('sendAssistantAccessDeniedEmail')"
                            (ngModelChange)="setSetting('sendAssistantAccessDeniedEmail', $event)"
                            (change)="updateOrganization()"
                            name="send-assistant-access-denied-email-for-organization"
                            labelPosition="after"
                          >
                            {{ 'SETTINGS.SEND_ASSISTANT_ACCESS_DENIED_EMAIL' | translate }}
                          </mat-slide-toggle>
                        </div>
                      </div>
                    }
                  </div>
                }
              }
            }
          }
          <div class="buttons-container">
            @if (saveUserSettingsMutation.result$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <p translate="SETTINGS.UNKNOWN_FAILURE"></p>
              }
            }
            @if (saveOrganizationSettingsMutation.result$ | async; as result) {
              @if (result.isPending) {
                <app-spinner></app-spinner>
              } @else if (result.isError) {
                <p translate="SETTINGS.UNKNOWN_FAILURE"></p>
              }
            }
          </div>
        </div>
      </div>
    }
  }
</div>
